import React, { useContext, useEffect, useState, useCallback, useMemo } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../config/AuthContext";
import {
    Button,
    Card,
    FloatButton,
    Modal,
    Progress,
    Space,
    Switch,
    Table,
    Tag,
    Tooltip,
    Typography,
    Input,
    message,
    Divider,
    Alert,
    Spin
} from "antd";
import { ColumnsType } from "antd/es/table";
import { GetProjecteId } from "../../../../dao/abp/GetProjecteId";
import { GetAlumnesTasquesByProject } from "../../../../dao/abp/GetAlumnesTasquesByProject";
import { GetGrupById } from "../../../../dao/abp/GetProjecteIdGrupId";
import { PutProjectesIdAlumnesIdTascaId } from "../../../../dao/abp/PutProjectesIdAlumnesIdTascaId";
import { PutProjectesIdAlumnesIdTascaIdComentaris } from "../../../../dao/abp/PutProjectesIdAlumnesIdTascaIdComentaris";
import AvaluacioColors from "../../../../styles/AvaluacioColors";
import { BiComment, BiRefresh, BiSolidGraduation, BiEdit, BiDetail } from "react-icons/bi";
import AvaluacioMassivaModal from "../../projecteId/AvaluacioMassivaModal";
import UseWebSocketSubscription from "../../../UseWebSocketSubscription";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { GetSprintStatus } from "../../../../dao/abp/GetSprintStatus";

const { Title, Text } = Typography;
const { TextArea } = Input;

interface Props {
    sprint: any;
    idProjecte?: string;
    idGrup?: string;
    readOnly?: boolean;
}

const gradeOptions = [
    { val: 0, label: 'P', full: 'Pendent (0)', color: 'default' },
    { val: 1, label: 'NP', full: 'No Presentat (1)', color: 'volcano' },
    { val: 2, label: 'M', full: 'Malament (2)', color: 'red' },
    { val: 5, label: 'S', full: 'Suficient (5)', color: 'orange' },
    { val: 6.5, label: 'B*', full: 'Bé amb retard (6.5)', color: 'cyan', late: true },
    { val: 7.5, label: 'B', full: 'Bé (7.5)', color: 'blue', late: false },
    { val: 8.5, label: 'MB*', full: 'Molt Bé amb retard (8.5)', color: 'purple', late: true },
    { val: 9, label: 'MB', full: 'Molt Bé (9)', color: 'gold', late: false },
    { val: 10, label: 'E', full: 'Excel·lent (10)', color: 'magenta', late: false },
];

const buildTree = (tasks: any[]) => {
    if (!tasks) return [];
    const taskMap: Record<number, any> = {};
    const roots: any[] = [];

    tasks.forEach(t => {
        taskMap[t.id] = { ...t, children: [] };
    });

    tasks.forEach(t => {
        if (t.id_tarea_padre) {
            if (taskMap[t.id_tarea_padre]) {
                taskMap[t.id_tarea_padre].children.push(taskMap[t.id]);
            } else {
                roots.push(taskMap[t.id]);
            }
        } else {
            roots.push(taskMap[t.id]);
        }
    });

    const sortAndFlatten = (node: any, depth: number, result: any[]) => {
        const { children, ...nodeWithoutChildren } = node;
        nodeWithoutChildren.depth = depth;
        result.push(nodeWithoutChildren);

        if (children && children.length > 0) {
            children.sort((a: any, b: any) => a.ordre - b.ordre);
            children.forEach((child: any) => sortAndFlatten(child, depth + 1, result));
        }
    };

    roots.sort((a: any, b: any) => a.ordre - b.ordre);

    const flatList: any[] = [];
    roots.forEach(root => sortAndFlatten(root, 0, flatList));

    return flatList;
};

const calcularProgreso = (lista: any[]) => {
    if (!lista || lista.length === 0) return 0;
    let totalCount = 0;
    let gradedCount = 0;
    lista.forEach(task => {
        if (task.grup && task.grup.length > 0) {
            task.grup.forEach((student: any) => {
                totalCount++;
                if (student.nota !== 0 && student.nota !== "0") gradedCount++;
            });
        }
    });
    return totalCount === 0 ? 0 : (gradedCount / totalCount) * 100;
};

const GradeChips = React.memo(({ currentVal, onSelect, loading, disabled, isSprintClosed, readOnly }: any) => {
    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', opacity: (loading || disabled) ? 0.6 : 1, pointerEvents: (loading || disabled) ? 'none' : 'auto' }}>
            {gradeOptions.map((opt: any) => {
                const isSelected = currentVal !== undefined && currentVal === opt.val;

                let isEnabled = true;
                if (opt.late === true && !isSprintClosed) isEnabled = false;
                if (opt.late === false && isSprintClosed) isEnabled = false;

                const isOptionDisabled = !isEnabled;

                return (
                    <Tooltip title={opt.full} key={opt.val}>
                        <Tag
                            color={isSelected ? opt.color : (isOptionDisabled ? undefined : 'default')}
                            style={{
                                cursor: (loading || disabled || readOnly || isOptionDisabled) ? 'not-allowed' : 'pointer',
                                border: isSelected ? undefined : `1px solid ${isOptionDisabled ? '#f0f0f0' : '#d9d9d9'}`,
                                opacity: isSelected ? 1 : (isOptionDisabled ? 0.4 : 0.7),
                                fontWeight: isSelected ? 'bold' : 'normal',
                                padding: '0 10px',
                                margin: 0,
                                fontSize: '12px',
                                height: '24px',
                                lineHeight: '22px',
                                transition: 'all 0.2s',
                                backgroundColor: isSelected ? undefined : (isOptionDisabled ? '#f9f9f9' : undefined),
                                color: isOptionDisabled && !isSelected ? '#ccc' : undefined
                            }}
                            onClick={() => !readOnly && !loading && !disabled && !isOptionDisabled && onSelect(opt.val)}
                        >
                            {opt.label}
                        </Tag>
                    </Tooltip>
                )
            })}
            {loading && <Spin size="small" style={{ marginLeft: 4 }} />}
        </div>
    );
});

const InternalCommentModal = ({
    visible,
    onCancel,
    onSave,
    initialValue,
    title,
    loading
}: {
    visible: boolean;
    onCancel: () => void;
    onSave: (val: string) => void;
    initialValue: string;
    title: string;
    loading: boolean;
}) => {
    const [value, setValue] = useState(initialValue);

    useEffect(() => {
        if (visible) setValue(initialValue);
    }, [visible, initialValue]);

    return (
        <Modal
            title={title}
            open={visible}
            onOk={() => onSave(value)}
            onCancel={onCancel}
            confirmLoading={loading}
            okText="Guardar"
            cancelText="Cancel·lar"
            destroyOnClose
        >
            <TextArea
                rows={6}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder="Escriu un comentari..."
                autoFocus
            />
        </Modal>
    );
};

const ProjecteIdTasques = (props: Props) => {
    const { isLoggedIn, userId, user, setBreadCrumb } = useContext(AuthContext);
    const params = useParams();
    const id_grup = props.idGrup || params.id_grup;
    const id_projecte = props.idProjecte || params.id_projecte;

    const [modules, setModules] = useState<any[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState(false);
    const [grup, setGrup] = useState<any>();
    const [selectedTask, setSelectedTask] = useState<any>(null);
    const [commentModalVisible, setCommentModalVisible] = useState(false);
    const [sprintStatus, setSprintStatus] = useState<any>(null);
    const [loadingGrades, setLoadingGrades] = useState<Record<string, boolean>>({});

    const [projecte, setProjecte] = useState<any>();
    const [groupData, setGroupData] = useState<any>();
    const [modalVisible, setModalVisible] = useState(false);
    const [isEvaluating, setIsEvaluating] = useState(false);
    const [currentCommentTask, setCurrentCommentTask] = useState<any>(null);
    const [currentCommentStudent, setCurrentCommentStudent] = useState<any>(null);

    useEffect(() => {
        if (props.sprint?.id && id_projecte && user) {
            checkSprintStatus();
        }
    }, [props.sprint, id_projecte, user]);

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [id_projecte, props.sprint]);

    async function checkSprintStatus() {
        try {
            const status = await GetSprintStatus(
                id_projecte + "",
                parseInt(props.sprint.id),
                user.tipus
            );
            setSprintStatus(status);
        } catch (error) {
            console.error('Error checking sprint status:', error);
        }
    }

    async function checkDades() {
        if (!id_projecte || !id_grup) return;
        setLoading(true);
        const projData = await GetProjecteId(id_projecte + "", parseInt(props.sprint.id));
        const grpData = await GetGrupById(id_grup + "");

        setProjecte(projData);
        setGroupData(grpData);

        const breadcrumbs = [
            { nom: 'Home', nav: '/home' },
            { nom: 'Avaluació', nav: '/abp' },
            { nom: 'Projectes', nav: '/abp/projectes' },
            { nom: `${projData.nom}`, nav: `/abp/projectes/${projData.id}` },
            { nom: 'Grups', nav: `/abp/projectes/${projData.id}` },
            {
                nom: `${grpData.alumnes?.map((v: any) => v.nom).join(', ')}`,
                nav: `/abp/projectes/${projData.id}/grups/${id_grup}/avaluacio`
            },
            { nom: 'Dashboard', nav: `/abp/projectes/${projData.id}/grups/${id_grup}/avaluacio` }
        ];

        setBreadCrumb(breadcrumbs, true);
        await checkTasques();
        setLoading(false);
    }

    async function checkTasques() {
        const dat = await GetAlumnesTasquesByProject(id_grup + "", id_projecte ? id_projecte : "0", parseInt(props.sprint.id));
        setModules(dat);
        setTotal(calcularProgreso(dat));
    }

    const treeData = useMemo(() => buildTree(modules), [modules]);

    const isSprintClosed = useMemo(() => {
        if (sprintStatus?.con_retraso === 1) return true;
        const endStr = props.sprint?.data_fi || props.sprint?.data_final;
        if (endStr) {
            const endDate = new Date(endStr);
            const now = new Date();
            return now > endDate;
        }
        return false;
    }, [sprintStatus, props.sprint]);

    const handleGradeChange = useCallback(async (studentId: string, task: any, val: number) => {
        const key = `${studentId}-${task.id}`;
        if (loadingGrades[key]) return;

        setLoadingGrades(prev => ({ ...prev, [key]: true }));

        const prevModules = [...modules];
        const newModules = modules.map(m => {
            if (m.id === task.id) {
                return {
                    ...m,
                    grup: m.grup.map((s: any) => {
                        if (s.id_usuari === studentId) {
                            return { ...s, nota: val + "" };
                        }
                        return s;
                    })
                };
            }
            return m;
        });
        setModules(newModules);
        setTotal(calcularProgreso(newModules));

        const student = task.grup.find((s: any) => s.id_usuari === studentId);
        const observacions = student ? student.observacions : '';

        try {
            await PutProjectesIdAlumnesIdTascaId(studentId, id_projecte + "", task.id, val + "", observacions || '', task.ordre, id_grup + "");
        } catch (e) {
            message.warning(`Error al guardar la nota per a l'alumne ${studentId}. Es revertiran els canvis.`);
            setModules(prevModules);
            setTotal(calcularProgreso(prevModules));
        } finally {
            setLoadingGrades(prev => ({ ...prev, [key]: false }));
        }
    }, [modules, id_projecte, id_grup, loadingGrades]);

    const handleGlobalGradeChange = useCallback(async (task: any, val: number) => {
        const key = `global-${task.id}`;
        if (loadingGrades[key]) return;

        setLoadingGrades(prev => ({ ...prev, [key]: true }));

        const prevModules = [...modules];
        const newModules = modules.map(m => {
            if (m.id === task.id) {
                return {
                    ...m,
                    avaluacio: val + "",
                    grup: m.grup.map((s: any) => ({ ...s, nota: val + "" }))
                };
            }
            return m;
        });
        setModules(newModules);
        setTotal(calcularProgreso(newModules));

        const observacions = task.observacions || '';

        try {
            await PutProjectesIdAlumnesIdTascaId("0", id_projecte + "", task.id, val + "", observacions, task.ordre, id_grup + "");
            message.success("Nota global aplicada");
        } catch (e) {
            message.warning("Error al guardar la nota global. Es revertiran els canvis.");
            setModules(prevModules);
            setTotal(calcularProgreso(prevModules));
        } finally {
            setLoadingGrades(prev => ({ ...prev, [key]: false }));
        }
    }, [modules, id_projecte, id_grup, loadingGrades]);

    const openCommentModal = useCallback((student: any, task: any) => {
        setCurrentCommentStudent(student);
        setCurrentCommentTask(task);
        setCommentModalVisible(true);
    }, []);

    const saveComment = useCallback(async (value: string) => {
        if (!currentCommentTask) return;
        setLoading(true);
        try {
            const idAlumne = currentCommentStudent ? currentCommentStudent.id_usuari : "0";
            await PutProjectesIdAlumnesIdTascaIdComentaris(
                idAlumne,
                id_projecte + "",
                currentCommentTask.id,
                value,
                id_grup + ""
            );
            message.success("Comentari guardat");
            setCommentModalVisible(false);
            await checkTasques();
        } catch (e) {
            message.error("Error al guardar comentari");
        }
        setLoading(false);
    }, [currentCommentTask, currentCommentStudent, id_projecte, id_grup]);

    const columnsProfe: ColumnsType<any> = useMemo(() => [
        {
            title: 'Tasca',
            key: 'info',
            width: '60%',
            render: (_: any, ele: any) => (
                <div style={{ paddingRight: 16, paddingLeft: ele.depth ? `${ele.depth * 40}px` : '10px', position: 'relative' }}>
                    {ele.depth > 0 && <div style={{ position: 'absolute', left: `${(ele.depth * 40) - 25}px`, top: '2px', color: '#8c8c8c', fontSize: '24px' }}>↳</div>}
                    <Space direction="vertical" style={{ width: '100%' }} size={10}>
                        <Space wrap>
                            <Tag color="blue" style={{ fontSize: 14, padding: '4px 10px' }}>{ele.modul}</Tag>
                            <Tag color="geekblue" style={{ fontSize: 14, padding: '4px 10px' }}>{ele.ranum || ele.ra}</Tag>
                            <Tag style={{ fontSize: 14, padding: '4px 10px' }}>{ele.pes}%</Tag>
                            {ele.depth > 0 && <Tag color="purple" style={{ fontSize: 14, padding: '4px 10px' }}>Subtasca</Tag>}
                            {ele.observacions && (
                                <Tooltip title={ele.observacions}>
                                    <BiComment size={18} style={{ color: AvaluacioColors.colors.color5, cursor: 'help', marginTop: 4 }} />
                                </Tooltip>
                            )}
                        </Space>

                        <div style={{
                            maxHeight: '150px',
                            overflowY: 'auto',
                            padding: '10px',
                            backgroundColor: '#fff',
                            border: '1px solid #f0f0f0',
                            borderRadius: '8px'
                        }}>
                            <ReactMarkdown
                                remarkPlugins={[remarkGfm]}
                                components={{
                                    p: ({ node, ...props }) => <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.5', color: '#333' }} {...props} />
                                }}
                            >
                                {ele.descripcio || ""}
                            </ReactMarkdown>
                        </div>

                        {isEvaluating && (
                            <div style={{
                                padding: '12px',
                                backgroundColor: '#f9f9f9',
                                borderRadius: '8px',
                                border: '1px solid #eaeaea',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 12
                            }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Text strong style={{ fontSize: '13px', color: '#666' }}>
                                        Avaluar tot el grup:
                                    </Text>
                                    <Space>
                                        <Tooltip title={ele.observacions || "Afegir comentari de grup"}>
                                            <Button
                                                icon={<BiComment />}
                                                onClick={() => openCommentModal(null, ele)}
                                                style={{
                                                    backgroundColor: ele.observacions ? AvaluacioColors.colors.color5 : undefined,
                                                    color: ele.observacions ? '#fff' : undefined,
                                                    borderColor: ele.observacions ? AvaluacioColors.colors.color5 : '#d9d9d9',
                                                }}
                                            >
                                                {ele.observacions ? "Grup" : ""}
                                            </Button>
                                        </Tooltip>
                                    </Space>
                                </div>
                                <GradeChips
                                    currentVal={ele.avaluacio !== undefined ? parseFloat(ele.avaluacio) : undefined}
                                    onSelect={(val: number) => handleGlobalGradeChange(ele, val)}
                                    loading={loadingGrades[`global-${ele.id}`]}
                                    isSprintClosed={isSprintClosed}
                                    readOnly={props.readOnly}
                                />
                            </div>
                        )}
                    </Space>
                </div>
            )
        },
        {
            title: 'Avaluació Individual',
            key: 'grades',
            render: (_: any, ele: any) => {
                if (!ele.grup || ele.grup.length === 0) return <Text type="secondary">Sense alumnes assignats</Text>;

                let displayedStudents = ele.grup;
                if (props.readOnly && user.tipus !== "1" && user.tipus !== "0") {
                    displayedStudents = ele.grup.filter((student: any) => student.id_usuari == userId);
                }

                return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: isEvaluating ? '12px' : '4px' }}>
                        {displayedStudents.map((student: any) => {
                            const hasComment = !!student.observacions;
                            const notaVal = parseFloat(student.nota);
                            const gradeInfo = gradeOptions.find(g => g.val === notaVal);

                            if (!isEvaluating) {
                                return (
                                    <div key={student.id_usuari} style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        borderBottom: '1px solid #f0f0f0',
                                        padding: '4px 0'
                                    }}>
                                        <Text style={{ fontSize: 13 }}>{student.nom}</Text>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                            {gradeInfo ? (
                                                <Tag color={gradeInfo.color} style={{ margin: 0 }}>
                                                    {gradeInfo.full}
                                                </Tag>
                                            ) : (
                                                <Tag style={{ margin: 0 }}>-</Tag>
                                            )}
                                            {hasComment && (
                                                <Tooltip title={student.observacions}>
                                                    <BiComment style={{ color: AvaluacioColors.colors.color5, cursor: 'help' }} />
                                                </Tooltip>
                                            )}
                                        </div>
                                    </div>
                                );
                            }

                            return (
                                <div key={student.id_usuari} style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: '8px',
                                    borderBottom: '1px solid #eee',
                                    paddingBottom: '8px'
                                }}>
                                    <div style={{ flex: 1 }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
                                            <Text strong style={{ fontSize: 13 }}>{student.nom}</Text>
                                            <Tooltip title={student.observacions || "Comentari individual"}>
                                                <Button
                                                    size="small"
                                                    type={hasComment ? "primary" : "text"}
                                                    ghost={hasComment}
                                                    style={{
                                                        height: 24,
                                                        padding: '0 8px',
                                                        fontSize: 12,
                                                        color: hasComment ? AvaluacioColors.colors.color5 : '#999',
                                                        borderColor: hasComment ? AvaluacioColors.colors.color5 : 'transparent'
                                                    }}
                                                    icon={<BiComment />}
                                                    onClick={() => openCommentModal(student, ele)}
                                                />
                                            </Tooltip>
                                        </div>
                                        <GradeChips
                                            currentVal={parseFloat(student.nota)}
                                            onSelect={(val: number) => handleGradeChange(student.id_usuari, ele, val)}
                                            loading={loadingGrades[`${student.id_usuari}-${ele.id}`]}
                                            isSprintClosed={isSprintClosed}
                                            readOnly={props.readOnly}
                                        />
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                );
            }
        },
        {
            title: 'Fet',
            key: 'fet',
            width: 50,
            align: 'center',
            render: (_: any, ele: any) => (
                <Switch disabled size="small" checked={ele.progresAlumne === 1} />
            )
        }
    ], [isEvaluating, loadingGrades, props.readOnly, user, userId, isSprintClosed, openCommentModal, handleGradeChange, handleGlobalGradeChange]);

    return (
        <>
            <Card
                title={
                    <Space direction="vertical" size={0}>
                        <Title level={4} style={{ margin: 0 }}>
                            Avaluació de Grup: {groupData?.codi || "..."}
                            {groupData?.alumnes && (
                                <Text type="secondary" style={{ fontSize: '14px', fontWeight: 'normal', marginLeft: 8 }}>
                                    ({groupData.alumnes.map((a: any) => `${a.nom} ${a.cognoms}`).join(", ")})
                                </Text>
                            )}
                        </Title>
                        <Text type="secondary">Sprint {props.sprint?.numero}: {props.sprint?.label}</Text>
                    </Space>
                }
                extra={
                    <div style={{ width: 'auto', display: 'flex', alignItems: 'center', gap: 8 }}>
                        {!props.readOnly && (user.tipus === "1" || user.tipus === "0") && (
                            <>
                                <Tooltip title="Avaluar Massivament">
                                    <Button
                                        icon={<BiSolidGraduation />}
                                        onClick={() => setModalVisible(true)}
                                    />
                                </Tooltip>
                                <Tooltip title="Refrescar dades">
                                    <Button
                                        icon={<BiRefresh />}
                                        onClick={() => checkDades()}
                                    />
                                </Tooltip>
                            </>
                        )}

                        {!props.readOnly && (
                            <Button
                                type={isEvaluating ? "default" : "primary"}
                                onClick={() => setIsEvaluating(!isEvaluating)}
                                icon={isEvaluating ? <BiDetail /> : <BiEdit />}
                                style={{
                                    backgroundColor: !isEvaluating ? AvaluacioColors.colors.color5 : undefined,
                                }}
                            >
                                {isEvaluating ? "Minimitzar" : "Avaluar"}
                            </Button>
                        )}
                        <Divider type="vertical" />
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, width: 200 }}>
                            <Text strong style={{ fontSize: 12 }}>Progrés:</Text>
                            <Progress percent={Math.round(total)} size="small" status="active" strokeColor={AvaluacioColors.colors.color5} />
                        </div>
                    </div>
                }
                bordered={false}
                className="shadow-sm"
                style={{ borderRadius: '12px' }}
            >
                {isSprintClosed && user.tipus === "2" && (
                    <Alert
                        message="Sprint Cerrado"
                        description="Este sprint ha finalizado. Las entregas tardías serán penalizadas en la evaluación."
                        type="warning"
                        showIcon
                        style={{ marginBottom: 16 }}
                        banner
                    />
                )}

                <Table
                    rowKey="id"
                    loading={loading}
                    columns={columnsProfe}
                    dataSource={treeData}
                    pagination={false}
                    bordered={false}
                    size="middle"
                    onRow={(record, rowIndex) => {
                        const isSubtask = record.depth > 0;
                        return {
                            style: {
                                background: isSubtask ? '#f5f7fa' : (rowIndex !== undefined && rowIndex % 2 === 0 ? '#fcfcfc' : '#ffffff'),
                                borderBottom: '4px solid #fff',
                                borderLeft: isSubtask ? `6px solid #babbbd` : '6px solid transparent'
                            }
                        };
                    }}
                    rowClassName={() => 'editable-row'}
                />
            </Card>

            {modalVisible && (
                <AvaluacioMassivaModal
                    alumnes={modules && modules.length > 0 ? modules[0].grup : []}
                    visible={modalVisible}
                    grup={id_grup + ""}
                    onClose={(val: boolean) => {
                        setModalVisible(false);
                        if (val) checkDades();
                    }}
                    srpint={props.sprint}
                    projecte={id_projecte + ""}
                />
            )}

            <InternalCommentModal
                visible={commentModalVisible}
                onCancel={() => setCommentModalVisible(false)}
                onSave={saveComment}
                initialValue={currentCommentStudent ? (currentCommentStudent.observacions || "") : (currentCommentTask?.observacions || "")}
                title={`Comentari ${currentCommentStudent ? `per a ${currentCommentStudent.nom}` : "Global (Grup)"}`}
                loading={loading}
            />
            <style>
                {`
               .ant-table-row > td {
                   border-bottom: 8px solid #f5f5f5 !important;
                   vertical-align: top;
               }
               `}
            </style>
        </>
    );
};

export default ProjecteIdTasques;
